import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#080A0B] pt-24 md:pt-32 pb-8 px-6 md:px-12 lg:px-16 border-t border-[#27272A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="mb-6">
              <img src={SITE.logo} alt="MarX Plumbing" className="h-28 md:h-32 w-auto object-contain" />
            </div>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-sm">
              A Sydney plumbing company built on quality workmanship, honest
              service and attention to detail since 2023.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 border border-[#27272A] flex items-center justify-center text-[#F4F0EB] hover:text-[#3FB8DC] hover:border-[#3FB8DC] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={SITE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 border border-[#27272A] flex items-center justify-center text-[#F4F0EB] hover:text-[#3FB8DC] hover:border-[#3FB8DC] transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <span className="text-[#A1A1AA] text-xs ml-2">{SITE.instagramHandle}</span>
            </div>
          </div>

          <div className="md:col-span-4">
            <span className="eyebrow block mb-5" style={{ fontSize: "0.6rem" }}>Visit</span>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-[#F4F0EB]/85">
                <MapPin className="w-4 h-4 text-[#3FB8DC] mt-0.5 flex-shrink-0" />
                {SITE.suburb}, {SITE.state}
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#3FB8DC] mt-0.5 flex-shrink-0" />
                <a href={SITE.phoneHref} className="text-[#F4F0EB]/85 hover:text-[#3FB8DC] transition-colors">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 min-w-0">
                <Mail className="w-4 h-4 text-[#3FB8DC] mt-0.5 flex-shrink-0" />
                <a
                  href={SITE.emailHref}
                  className="text-[#F4F0EB]/85 hover:text-[#3FB8DC] transition-colors break-all"
                >
                  {SITE.email}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="eyebrow block mb-5" style={{ fontSize: "0.6rem" }}>Hours</span>
            <ul className="space-y-3 text-sm">
              {SITE.hours.map((h) => (
                <li key={h.day} className="flex justify-between text-[#F4F0EB]/85">
                  <span>{h.day}</span>
                  <span className="text-[#A1A1AA]">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 md:mt-24 select-none">
          <div
            aria-hidden
            className="font-serif-display text-[#F4F0EB]/[0.04] leading-none tracking-tighter"
            style={{ fontSize: "clamp(5rem, 18vw, 16rem)" }}
          >
            MarX.
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#27272A] flex flex-col md:flex-row justify-between gap-4 text-xs text-[#A1A1AA]">
          <span>© {new Date().getFullYear()} MarX Plumbing. All rights reserved. {SITE.license}</span>
          <span>
            {SITE.established} · {SITE.suburb}, {SITE.state}, {SITE.country}
          </span>
        </div>
      </div>
    </footer>
  );
}
